import { Box, Typography, Button, Link } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const InventoryManagement = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="30px auto"
      p="30px"
      maxWidth="800px"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 3px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack sx={{ transition: "transform 0.2s ease" }} />}
        onClick={() => navigate(-1)}
        sx={{
          color: "colors.primary[200]",
          backgroundColor: "transparent",
          fontWeight: "bold",
          "&:hover .MuiButton-startIcon": {
            transform: "translateX(-7px)",
          },
        }}
      >
        Back
      </Button>

      {/* Project Title */}
      <Typography
        variant="h3"
        fontWeight="bold"
        color={colors.primary[200]}
        my={2}
      >
        <Link
          href="/comingsoon"
          target="_blank"
          underline="none"
          color="inherit"
          sx={{
            textDecoration: "none",
            px: 1,
            borderRadius: 1,
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor: "grey.300",
              cursor: "pointer",
            },
          }}
        >
          Inventory Management
        </Link>
      </Typography>

      {/* Project Description */}
      <Typography variant="h5" color={colors.primary[200]} mb={3}>
        A inventory management tool for small business supply chains
      </Typography>

      {/* Demo Section */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Demo:
      </Typography>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/wzHedZNH0eA"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>

      {/* Technical Challenges */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technical Challenges:
      </Typography>
      <Box component="ul" color={colors.primary[200]} mb={3}>
        <li>Designing an easy and intuitive interface</li>
        <li>Creating scalable storage for products</li>
        <li>Fetch products and render fast for responsive pages</li>
      </Box>

      {/* Features to work on  */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Features:
      </Typography>
      <Box component="ul" color={colors.primary[200]} mb={3}>
        <li>Store multiple photos for each product</li>
        <li>Easily view, create, update and delete products in inventory</li>
      </Box>

      {/* Technologies used */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technologies used:
      </Typography>
      <Box
        display={"flex"}
        flexWrap="wrap"
        maxWidth="800px"
        sx={{ pl: 3, color: colors.primary[200], mb: 3 }}
      >
        {[
          "Next.js",
          "React",
          "TypeScript",
          "Python",
          "Shadcn",
          "Zod",
          "Multer",
          "GraphQL",
          "FastAPI",
          "Stripe",
          "S3",
          "DynamoDB",
        ].map((tech) => (
          <Box
            key={tech}
            component=""
            sx={{
              px: 1.5,
              py: 0.5,
              m: 0.5,
              border: `1px solid ${colors.primary[200]}`,
              borderRadius: "8px",
              color: colors.primary[200],
              fontSize: "0.875rem",
              backgroundColor: "rgba(255, 255, 255, 0.05)", // Subtle background
              "&:hover": {
                backgroundColor: colors.primary[200],
                color: "#000", // Contrast color on hover
                cursor: "default",
              },
            }}
          >
            {tech}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default InventoryManagement;
